<template>
  <div class="mainSpinerDiv" v-if="showSpinner">
    <div class="spinerPosition">
      <!-- :class="spinnerType == 'border' ? 'spinner-border' : 'spinner-grow'" -->
      <!-- <span class="mx-3" :class="spinnerClass" role="status"></span> -->
      <i class="fi fi-orbit fi-spin mx-3 fs-1"></i>
      <span>{{ message }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      required: false,
      default: '',
    },
    spinnerType: {
      type: String,
      required: false,
      default: 'border',
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
  },
  data() {
    return {
      showSpinner: false,
      spinnerClass: null,
    };
  },
  methods: {
    show() {
      this.showSpinner = true;
    },
    hide() {
      this.showSpinner = false;
    },
  },
  mounted() {
    switch (this.color) {
      case 'primary':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-primary spinner-border';
        } else {
          this.spinnerClass = 'text-primary spinner-grow';
        }
        break;
      case 'secondary':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-secondary spinner-border';
        } else {
          this.spinnerClass = 'text-secondary spinner-grow';
        }
        break;
      case 'success':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-success spinner-border';
        } else {
          this.spinnerClass = 'text-success spinner-grow';
        }
        break;
      case 'danger':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-danger spinner-border';
        } else {
          this.spinnerClass = 'text-danger spinner-grow';
        }
        break;
      case 'warning':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-warning spinner-border';
        } else {
          this.spinnerClass = 'text-warning spinner-grow';
        }
        break;
      case 'info':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-info spinner-border';
        } else {
          this.spinnerClass = 'text-info spinner-grow';
        }
        break;
      case 'light':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-light spinner-border';
        } else {
          this.spinnerClass = 'text-light spinner-grow';
        }
        break;
      case 'dark':
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-dark spinner-border';
        } else {
          this.spinnerClass = 'text-dark spinner-grow';
        }
        break;
      default:
        if (this.spinnerType == 'border') {
          this.spinnerClass = 'text-primary spinner-border';
        } else {
          this.spinnerClass = 'text-primary spinner-grow';
        }
        break;
    }
  },
};
</script>

<style scoped>
.mainSpinerDiv {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  background-color: #a9aad285;
}
.spinerPosition {
  position: fixed;
  left: 45vw;
  top: 45vh;
  z-index: 10000;
}
</style>
